import { render } from "./KanCore.vue?vue&type=template&id=26e5764e"
import script from "./KanCore.vue?vue&type=script&lang=js"
export * from "./KanCore.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__